import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List, Toast } from 'antd-mobile'
import { setHeader } from '@/util/set-header'
import {
  fetchPayBase as fetchPayBaseApi,
  fetchDeposit as fetchDepositApi,
} from '@/api/payment'
import SelectPay from '../common/select-pay/select-pay'
import PayGroup from '../common/pay-group'
const { Item } = List
const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}

@(connect(mapStateToProps) as any)
export default class Deposit extends Component<any, any> {
  state: any = {
    data: {
      info: {},
      deposit: {},
    },
    depositFee: 0,
    loading: true,
  }

  params = {
    pay_type: 'alipay',
    money: '',
  }

  componentDidMount() {
    setHeader({ title: '缴费', leftClick: this.leftClick })
    Toast.loading('加载中', 0)
  }

  leftClick = () => {
    //返回App我的订单
    const { history } = this.props
    if(history.length>1){
      history.goBack()
    }else{
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }

  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    if (info.checkin_id !== nextInfo.checkin_id) {
      await Promise.all([
        this.setData(nextInfo.checkin_id),
        this.setPrices(nextInfo.checkin_id),
      ])
      Toast.hide()
      this.setState({ loading: false })
    }
  }

  async setData(checkin_id: string) {
    const { data } = await fetchPayBaseApi(checkin_id)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    this.setState({ data: data.data })
  }

  async setPrices(checkin_id: string) {
    const { data } = await fetchDepositApi(checkin_id)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    this.setState({ depositFee: data.data })
  }

  get total() {
    const { depositFee } = this.state
    if (depositFee) {
      return parseFloat(depositFee)
    }
    return ''
  }

  loadData = () => {
    const { data } = this.state
    const { deposit } = data
    const { subject_id, subject_name } = deposit
    return {
      pay_type: this.params.pay_type,
      cost_data: [
        {
          money: this.total,
          subject_id,
          subject_name,
        },
      ],
    }
  }

  render() {
    const { name } = this.props.info
    const { info, deposit } = this.state.data
    const { depositFee } = this.state
    const { total } = this
    return (
      <div className="pay-form">
        <List>
          <Item>
            <span className="label">缴费人</span>
            <span className="value">{name}</span>
          </Item>
          <Item>
            <span className="label">房间号</span>
            <span className="value">{`${info.store_no || ''}-${info.room_no ||
              ''}-${info.bed_no || ''}`}</span>
          </Item>
        </List>
        <div className="line" />
        <List>
          <Item>
            <span className="label">缴费项目</span>
            <span className="value subject-name">{deposit.subject_name}</span>
          </Item>
          <Item>
            <span className="label">充值金额</span>
            <span className="value">{parseFloat(depositFee).toFixed(2)}元</span>
          </Item>

          <SelectPay onChange={type => (this.params.pay_type = type)} />
        </List>
        <PayGroup money={total} loadData={this.loadData} />
      </div>
    )
  }
}
